import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinpune() {



  const cardData = {
    "keyword": "Tempo Traveller On Rent in Pune",

    "headingDescription":
      "Aaradhya Travels offers reliable and affordable Tempo Traveller on Rent in Pune for family trips, group tours, corporate travel, weddings, outstation journeys, and pilgrimage tours. Our fleet includes well-maintained 9, 12, 17, 20, 26-seater tempo travellers designed for maximum comfort and safety. All vehicles are equipped with pushback seats, air-conditioning, ample luggage space, and experienced drivers who ensure a smooth travel experience across Pune and Maharashtra routes. Whether you are planning a one-day local trip, weekend getaway, or long outstation journey, we provide flexible rental options with transparent pricing and 24/7 support. Aaradhya Travels focuses on comfort, punctuality, and safe group travel, making every journey hassle-free and enjoyable.",

"topPlaces": [
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},
{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
},
  {
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},

],



    services: [
      {
        name: "Tempo Traveller in Pune",
        description: "Tempo Traveller in Pune service provides comfortable and spacious travel solutions for family trips, corporate outings, group tours, and outstation journeys across Maharashtra and India. Well-maintained vehicles with professional drivers ensure smooth highway travel for long-distance routes and local sightseeing requirements. Vehicles are suitable for airport transfers, wedding transportation, pilgrimage tours, and weekend vacations. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Flexible booking options allow convenient Tempo Traveller reservations for all travel needs."
      },
      {
        name: "17 Seater Bus on Rent in Pune Price",
        description: "17 seater bus on rent in Pune price service offers affordable and reliable transportation for group travel, corporate events, school trips, family tours, and outstation journeys. Spacious seating and comfortable interiors ensure smooth travel for long-distance routes and local sightseeing requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 17 seater bus reservations."
      },
      {
        name: "17 Seater Tempo Traveller on Rent in Pune",
        description: "17 seater Tempo Traveller on rent in Pune service provides spacious transportation for family vacations, group tours, corporate travel, and pilgrimage journeys. Comfortable pushback seating and smooth suspension ensure enjoyable travel experiences for passengers across local and outstation routes. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 17 seater Tempo Traveller reservations."
      },
      {
        name: "Traveller on Rent Pune",
        description: "Traveller on rent Pune service offers dependable transportation for group tours, airport transfers, family outings, wedding functions, and corporate travel requirements. Spacious vehicles ensure comfortable highway journeys suitable for long-distance travel and local sightseeing trips. Professional drivers provide safe driving and punctual pickup services across all major Pune locations. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller rental reservations."
      },
      {
        name: "Traveller Bus on Rent in Pune",
        description: "Traveller bus on rent in Pune service provides reliable and economical transportation for group travel, educational tours, family functions, and corporate events. Comfortable seating and spacious interiors ensure smooth journeys for local and outstation travel requirements. Professional chauffeurs ensure safe transportation and timely pickup services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow easy traveller bus rental reservations."
      },
      {
        name: "Tempo Traveller on Rent Pune to Outstation",
        description: "Tempo Traveller on rent Pune to outstation service offers comfortable transportation for long-distance travel including Goa, Shirdi, Mahabaleshwar, Nashik, Kolhapur, and other tourist destinations. Spacious vehicles with luggage capacity ensure smooth highway journeys for families, corporate groups, and tourists. Professional drivers provide reliable and safe travel services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation traveller reservations."
      },
      {
        name: "Tempo Traveller on Rent in Pune",
        description: "Tempo Traveller on rent in Pune service provides premium travel solutions for local sightseeing, outstation trips, wedding transportation, and group travel requirements. Comfortable seating and spacious interiors ensure pleasant journeys for families, tourists, and corporate passengers. Professional drivers ensure smooth and safe travel experiences throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Tempo Traveller reservations."
      },
      {
        name: "Pune to Shirdi Tempo Traveller Rate",
        description: "Pune to Shirdi Tempo Traveller rate service offers economical and reliable transportation for devotees and travelers planning Shirdi Sai Baba temple visits from Pune. Spacious vehicles ensure comfortable highway travel suitable for family darshan tours, pilgrimage groups, and senior citizen travel. Professional drivers provide safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Shirdi traveller reservations."
      },
      {
        name: "Tempo Traveller Hire in Pune",
        description: "Tempo Traveller hire in Pune service provides dependable transportation for group tours, corporate outings, wedding events, educational trips, and airport transfers. Comfortable vehicles with spacious seating ensure smooth travel experiences across local and outstation routes. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow easy Tempo Traveller hire reservations."
      },
      {
        name: "Tempo Traveller on Rent in Hadapsar",
        description: "Tempo Traveller on rent in Hadapsar service provides comfortable transportation for families, corporate teams, and tourists planning local and outstation trips from Hadapsar Pune. Spacious vehicles ensure smooth highway travel suitable for weekend vacations, airport transfers, and group outings. Professional chauffeurs ensure timely pickup and safe driving services throughout the trip. Pickup services are available from residential societies, offices, hotels, and commercial areas across Hadapsar. Flexible booking options allow convenient traveller reservations."
      },
      {
        name: "Tempo Traveller on Rent in Pune Rate Per KM",
        description: "Tempo Traveller on rent in Pune rate per km service offers transparent and affordable travel solutions for local and outstation group journeys. Comfortable vehicles ensure smooth travel suitable for family tours, corporate trips, and pilgrimage travel requirements. Professional drivers provide safe transportation and punctual pickup services across all major routes. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient traveller rental bookings."
      },
      {
        name: "Tempo Traveller Rental Pune",
        description: "Tempo Traveller rental Pune service provides reliable transportation for group vacations, business travel, weddings, educational tours, and religious journeys. Spacious interiors and comfortable seating ensure pleasant highway travel for long-distance and local routes. Professional chauffeurs ensure safe driving and dependable transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller rental reservations."
      },
      {
        name: "Pune to Mahabaleshwar Cab Tempo Traveller",
        description: "Pune to Mahabaleshwar cab Tempo Traveller service offers comfortable hill station transportation for family vacations, group tours, and weekend getaway trips. Spacious vehicles ensure smooth ghat road travel suitable for tourists and corporate groups. Professional drivers provide safe driving and reliable travel services throughout the Mahabaleshwar route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
      },
      {
        name: "Pune to Goa Tempo Traveller on Rent",
        description: "Pune to Goa Tempo Traveller on rent service provides premium transportation for beach vacations, family trips, bachelor parties, and corporate outings from Pune. Spacious seating and luggage space ensure comfortable long-distance travel for passengers heading to Goa destinations. Professional chauffeurs ensure safe highway driving and smooth overnight journeys. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Goa traveller reservations."
      },
      {
        name: "Luxury Tempo Traveller on Rent in Pune",
        description: "Luxury Tempo Traveller on rent in Pune service offers premium travel experiences with comfortable interiors, pushback seating, air conditioning, and spacious cabins for luxury group travel. Vehicles are suitable for weddings, VIP transportation, corporate events, family vacations, and outstation journeys. Professional chauffeurs ensure smooth and safe travel experiences throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury traveller reservations."
      },
      {
        name: "Traveller on Rent in Pimpri Chinchwad",
        description: "Traveller on rent in Pimpri Chinchwad service provides dependable transportation for local travel, airport transfers, family functions, and outstation group tours. Comfortable vehicles ensure smooth journeys suitable for corporate employees, tourists, and families. Professional drivers ensure punctual pickup and safe driving services across all routes. Pickup services are available from residential areas, offices, hotels, and commercial locations across Pimpri Chinchwad. Flexible booking options allow convenient traveller rental reservations."
      },
      {
        name: "Traveller on Rent in Hinjewadi",
        description: "Traveller on rent in Hinjewadi service offers reliable transportation for IT professionals, corporate teams, airport transfers, and group outings from Hinjewadi Pune. Spacious vehicles ensure comfortable travel suitable for office events, business tours, and weekend trips. Professional chauffeurs provide safe driving and timely pickup services throughout the journey. Pickup services are available from IT parks, offices, residential societies, hotels, and commercial areas across Hinjewadi. Flexible booking options allow easy traveller rental reservations."
      },
      {
        name: "Traveller on Rent in Wakad Pune",
        description: "Traveller on rent in Wakad Pune service provides comfortable and economical transportation for local sightseeing, family tours, airport transfers, and corporate travel requirements. Spacious vehicles ensure smooth highway travel suitable for group journeys and weekend vacations. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Wakad Pune. Flexible booking options allow convenient traveller reservations."
      },
      {
        name: "Traveller on Rent in Baner Pune",
        description: "Traveller on rent in Baner Pune service offers dependable transportation for families, tourists, corporate employees, and groups planning local and outstation travel. Comfortable vehicles ensure pleasant highway journeys suitable for airport transfers, business travel, and holiday trips. Professional chauffeurs ensure safe driving and timely pickup services across all major routes. Pickup services are available from homes, offices, hotels, and commercial areas across Baner Pune. Flexible booking options allow convenient traveller rental reservations."
      }
    ],

    tableData: [
      ["Tempo Traveller in Pune", "17 Seater Bus on Rent in Pune Price"],
      ["17 Seater Tempo Traveller on Rent in Pune", "Traveller on Rent Pune"],
      ["Traveller Bus on Rent in Pune", "Tempo Traveller on Rent Pune to Outstation"],
      ["Tempo Traveller on Rent in Pune", "Pune to Shirdi Tempo Traveller Rate"],
      ["Tempo Traveller Hire in Pune", "Tempo Traveller on Rent in Hadapsar"],
      ["Tempo Traveller on Rent in Pune Rate Per KM", "Tempo Traveller Rental Pune"],
      ["Pune to Mahabaleshwar Cab Tempo Traveller", "Pune to Goa Tempo Traveller on Rent"],
      ["Luxury Tempo Traveller on Rent in Pune", "Traveller on Rent in Pimpri Chinchwad"],
      ["Traveller on Rent in Hinjewadi", "Traveller on Rent in Wakad Pune"],
      ["Traveller on Rent in Baner Pune", "Tempo Traveller in Pune"]
    ],


    whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller On Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for outstation tours, family trips, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller on rent in Pune with transparent pricing, flexible booking options, and complete travel package details without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Tempo Traveller rental service in Pune is available 24 hours for airport transfers, wedding travel, corporate tours, family vacations, pilgrimage tours, and emergency travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are air-conditioned, spacious, clean, and regularly sanitized to ensure comfortable travel experiences for every passenger."
      },
      {
        WhyChooseheading: "One Day & Outstation Group Tours",
        WhyChoosedescription: "Aaradhya Travels offers flexible travel plans including one-day trips, weekend tours, multi-day outstation journeys, and customized group travel packages from Pune."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from multiple Tempo Traveller seating options including 13 seater, 17 seater, and 20 seater vehicles suitable for families, tourists, corporate teams, and pilgrimage groups."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, Pimpri, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Long Distance Travel",
        WhyChoosedescription: "Our skilled drivers are experienced in handling long-distance highway travel and tourist routes, ensuring safe journeys and timely arrival for every group trip."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller on rent in Pune?", answer: "Tempo Traveller on rent in Pune provides comfortable group travel vehicles for outstation trips, family tours, corporate travel, and local sightseeing." },
    { question: "Is Tempo Traveller booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller rental service in Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group sizes." },
    { question: "Can I book Tempo Traveller for outstation travel?", answer: "Yes, customers can book Tempo Travellers for outstation trips, hill stations, pilgrimage tours, and long-distance travel." },
    { question: "Do you provide Tempo Traveller for corporate tours?", answer: "Yes, Aaradhya Travels provides Tempo Travellers for corporate events, office trips, conferences, and team outings." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Tempo Traveller online in Pune?", answer: "Yes, customers can easily book Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Tempo Traveller for family trips?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers ideal for family vacations and group tours." },
    { question: "Are Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden costs." },
    { question: "Is advance booking available for Tempo Traveller rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive travel seasons." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shinde",
    feedback:
      "We hired a Tempo Traveller on rent in Pune for a group trip and the overall experience was very smooth. The vehicle was clean, comfortable, and perfect for long-distance travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Our family used a Tempo Traveller rental service in Pune and were really satisfied with the journey. Seating was spacious, driving was safe, and everything was well managed.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/tempo-traveller-on-rent-pune.jpg",
  "description": "Book Tempo Traveller on rent in Pune with Aaradhya Travels for family trips, corporate tours, weddings, airport transfers, and outstation travel. Affordable 17 seater luxury tempo traveller available for Pune to Shirdi, Goa, Mahabaleshwar, Mumbai and more.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3821"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/tempo-traveller-on-rent-in-pune"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Tempo Traveller On Rent in Pune | 17 Seater Luxury Traveller | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Tempo Traveller on rent in Pune with Aaradhya Travels. Affordable 17 seater luxury tempo traveller for Pune local sightseeing, corporate tours, weddings, airport transfers, and outstation trips to Shirdi, Goa, Mahabaleshwar, Mumbai and more."
  />

  <meta
    name="keywords"
    content="Tempo traveller in Pune, 17 seater bus on rent in pune price, 17 seater tempo traveller on rent in Pune, Traveller on rent pune, Traveller bus on rent in pune, Tempo Traveller on rent pune to Outstation, Tempo traveller on rent in pune, 17 seater tempo traveller on rent in pune, pune to shirdi tempo traveller rate, Tempo Traveller hire in pune, Tempo Traveller on rent in hadapsar, Tempo Traveller on rent in pune rate per km, Tempo Traveller Rental Pune, pune to mahabaleshwar cab tempo Traveller, Pune to goa tempo traveller on Rent, Luxury Tempo Traveller Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentinpune;